<template>
  <div class="mh bg-main" v-if="isShowPage">
    <!-- 背景图片 -->
    
    <div class="bg">
      <div class="bgImg">
        <div class="pageTitle">在线报读平台</div>
        <img src="@/assets/img/bjing@2x.png" alt="" />
      </div>
     
    </div>
    <!-- form表单 -->
    <div class="contentWrap">
      <van-form @submit="onSubmit">
        <div class="everyIpt">
          <van-field
          label-width="80px"
          name="phone"
          type="tel"
          v-model.trim="loginForm.phone"
          placeholder="请填写手机号码"/>
        </div>
        <div class="everyIpt">
          <van-field
            v-model="loginForm.code"
            center
            name="code"
            placeholder="请输入短信验证码">
            <template #button>
              <van-button size="small" type="danger" @click="sendCodeFn" class="getCodeBtn">{{codeNum != 60 ? codeNum + '(s)' : '发送验证码'}}</van-button>
            </template>
          </van-field>
        </div>
        <div class="everyIpt"><van-button type="danger" block native-type="submit">登录</van-button></div>
      </van-form>
    </div>
    <van-overlay :show="noBaodu" @click="noBaodu = false">
      <div class="wrapper" @click.stop>
        <van-empty image="search"/> 
        <p class="noDataTitle">未查询到您的报读信息</p>
        <div class="noDataOther">请关注“中央广播电视中等专业学校”微信公众号的“在线报名”进行报读</div>
        <div class="goBtn" @click="goBaodu">前去报读</div>
      </div>
    </van-overlay>

  </div>
</template>
<script>
import  {sendCode,phoneLogin,wxOpenidLogin} from '@/api/login'
import { Toast } from 'vant';
export default {
  name: "login",
  data() {
    return {
      isShowPage: false,
      noBaodu: false,
      timer: null,
      codeNum: 60,
      loginForm: {
        phone: '',
        code: '',
        openId: ''
      },
      projectType: '', // 没有是中专招生 有：统一门户
    };
  },
  created() {
    localStorage.clear()
    const {uuid,openId,type} = this.$route.query
    this.loginForm.openId = openId
    this.projectType = type // 有： 统一门户 没有：中专招生
    this.loginForm.type = type
    this.loginForm.uuid = uuid
    wxOpenidLogin({openId: this.loginForm.openId}).then(res=>{
      this.$store.commit('setToken', res.token || '');
      this.$store.commit('setUserId', res.userId || '');
      this.$store.commit('setStudentNo', res.studentNo || '');
      this.$router.push({path: '/personCenter'})
    }).catch(err=>{
      // 学生还没有报名
      this.isShowPage = true
    })
  },
  methods: {
    // 发送验证码
    sendCodeFn() {
      if (this.timer) {
        return
      }
      let phone = this.loginForm.phone
      if (!phone) {
        Toast({
          message: '请输入手机号',
          position: 'top',
        });
        return
      }
      sendCode({phone}).then(res=>{
        this.timer = setInterval(()=>{
          this.codeNum = --this.codeNum
          if (this.codeNum <= 0) {
            this.codeNum = 60
            clearInterval(this.timer)
            this.timer = null
          }
      },1000)

      })
    },
    onSubmit() {
      if (!this.loginForm.phone) {
        Toast({
          message: '请输入手机号',
          position: 'top',
        });
        return
      }
      if (!this.loginForm.code) {
        Toast({
          message: '请输入验证码',
          position: 'top',
        });
        return
      }

      if (this.loginForm.phone && this.loginForm.code) {
        phoneLogin(this.loginForm).then(res=>{
          if (this.loginForm.uuid) { // 统一门户
            this.$router.push({path: '/success',query: {type: this.projectType}})
            return
          }
          this.$store.commit('setToken', res.token || '');
          this.$store.commit('setUserId', res.userId || '');
          this.$store.commit('setStudentNo', res.studentNo || '');
          this.$store.commit('setApprovalStatus', res.approvalStatus);
            this.$store.commit('setUserUniqueId', res.userUniqueId || '');
          this.$router.push({path: '/personCenter'})
          this.noBaodu = false
        }).catch(err=>{
          if (this.loginForm.uuid) { // 统一门户
            this.$router.push({path: '/success',query: {type: this.projectType}})
            return
          }
          this.noBaodu = true
        })
      }
    },
    goBaodu() {
      this.$router.replace({path: '/home'})
    },

  },

};
</script>

<style scoped>
/* 背景图片 */
.bgImg {
  position: relative;
  width: 100%;
  height: 272px;
  z-index: 0;
}
.bgImg img {
  width: 100%;
  height: 100%;
}
.bgImg .pageTitle {
  position: absolute;
  top: 82px;
  left: 26px;
  font-size: 25px;
  font-weight: bold;
  color: #FFFFFF;
}
.appName {
  width: 171px;
  background-color: #ffffff4b;
  text-align: center;
  height: 24px;
  line-height: 24px;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  position: absolute;
  top: 104px;
  left: 50%;
  transform: translate(-50%, 0);
}
.contentWrap {
  position: relative;
  top: -10px;
  padding: 50px 10px;
  margin:0 10px;
  background-color: #ffffff;
  border-radius: 5px;
}
.everyIpt {
  overflow: hidden;
  border-radius: 10px;
}
.everyIpt:not(:last-child) {
  margin-bottom: 25px;
  border: 1px solid #ddd;
}

input::webkit-input-placeholder {
  font-weight: bold;
   color: #624b2f;
}

.wrapper {
  height: 55%;
  width: 80%;
  background-color: #fff;
  border-radius: 10%;
  text-align: center;
}

.wrapper .noDataTitle {
  font-weight: bold;
}

.wrapper .noDataOther {
  padding: 0 30px;
  font-size: 13px;
  color: #666;
  line-height: 20px;
  margin: 10px 0;
}
.wrapper .goBtn {
  line-height: 40px;
  width: 100px;
  background-color: #f00;
  margin: 0 auto;
  border-radius: 10px;
  color: #fff;
  font-weight: bold;
}
</style>
